<!-- ========================================================= -->
<!-- Reusable Button Component                                -->
<!-- ========================================================= -->

<!-- [disabled]="disabled" → Disables button when true -->
<!-- class="btn" → Base button styling -->

<!-- [ngStyle] → Applies width if provided -->

<!--
  [ngClass] → Applies dynamic classes:
  - disabled      → When button is disabled
  - size           → sm / md / lg
  - primary        → Primary variant
  - secondary      → Secondary variant
  - tertiary       → Tertiary variant
  - text           → Text variant
  - text-light     → Light text variant
  - quaternary     → Dark Blue variant
  - customClass    → Extra custom class from parent
-->

<!-- (click) → Emits click handler -->
<!-- [type] → Button type (button / submit / reset) -->

<button
  [disabled]="disabled"
  class="btn"
  [ngStyle]="{ width: width || null }"
  [ngClass]="[
    disabled ? 'disabled' : '',
    size ? size : '',
    variant === 'primary' && !disabled ? 'primary' : '',
    variant === 'secondary' && !disabled ? 'secondary' : '',
    variant === 'tertiary' && !disabled ? 'tertiary' : '',
    variant === 'text' && !disabled ? 'text' : '',
    variant === 'text-light' && !disabled ? 'text-light' : '',
    variant === 'quaternary' && !disabled ? 'quaternary' : '',
    icon ? 'has-icon' : '',
    customClass,
    btnShape
  ]"
  (click)="onClick()"
  [type]="type"
  [id]="btnId"
  matTooltip="{{ tooltip }}"
  [matTooltipDisabled]="!tooltip"
  matTooltipClass="eap-tooltip-yellow"
>

  <!-- Label displayed when icon is at the end -->
  <span
    *ngIf="label && !iconSm && iconPosition == 'end'"
    [ngClass]="disabled ? 'btn-text-disabled' : variant === 'text-light' || variant === 'quaternary' ? 'text-white' : 'btn-text'">
    {{ label }}
  </span>

  <!-- Small icon -->
  <ng-container *ngIf="iconSm">
    <mat-icon
      class="material-symbols-outlined btn-icon"
      [ngClass]="{
        'btn-icon-err': error,
        'btn-icon-disabled': disabled,
        'sm-icon': iconSm
      }"
    >
      {{ iconSm }}
    </mat-icon>
  </ng-container>

  <!-- Normal icon -->
  <ng-container *ngIf="icon">
    <mat-icon
      class="btn-icon material-symbols-outlined pt-1"
      [ngClass]="{
        'btn-icon-err': error,
        'btn-icon-disabled': disabled
      }"
    >
      {{ icon }}
    </mat-icon>
  </ng-container>

  <!-- Slot for projected custom content -->
  <ng-content></ng-content>

  <!-- Label displayed when icon is at the start -->
  <span
    *ngIf="label && !iconSm && iconPosition == 'start'"
    [ngClass]="disabled ? 'btn-text-disabled' : variant === 'text-light' || variant === 'quaternary' ? 'text-white' : 'btn-text'">
    {{ label }}
  </span>

</button>
